<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fpbttt/tc-custom/9783965375703.jpg?1703042544858" alt="This image is the cover for the book A Man of Mark, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Man of Mark, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>A Man of Mark (1890) is notable primarily for its similarities to Zenda: it is set in an imaginary country, Aureataland and features political upheaval and humour. (Excerpt from Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Hope
      </h2>
      
      <p class="authorDescription body article">Sir Anthony Hope Hawkins, better known as Anthony Hope (9 February 1863 – 8 July 1933), was an English novelist and playwright. He was a prolific writer, especially of adventure novels but he is remembered predominantly for only two books: The Prisoner of Zenda (1894) and its sequel Rupert of Hentzau (1898). These works, "minor classics" of English literature, are set in the contemporaneous fictional country of Ruritania and spawned the genre known as Ruritanian romance, works set in fictional European locales similar to the novels. Zenda has inspired many adaptations, most notably the 1937 Hollywood movie of the same name. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32c603a6